module.exports = __webpack_public_path__ + "img/echarts3.39c45674.png";